import {useTransition} from '@logistics-frontend/blocks'
import {useFormContext} from '@yandex-delivery/form'
import {memo} from 'react'
import {useLocation} from 'react-router-dom'

import {fetchInitialRoute} from 'src/shared/api'
import type {Order as FormValues} from 'src/shared/types'

type Props = {
  defaultValues: FormValues
}

/**
 * @description как оказалось, [асинхронный дефолтный стейт](https://react-hook-form.com/docs/useform#defaultValues)
 * плохо работает с хуком useFieldArray у самого RHF (в нашем случае отвалились destinationPoints),
 * есть даже пара ишью на этот счет:
 *   - [раз](https://github.com/react-hook-form/react-hook-form/issues/832)
 *   - [два](https://github.com/react-hook-form/react-hook-form/issues/1870)
 *
 * поэтому пришлось вкрутить такие костыли для каких-то начальных значений по-умолчанию, которые требуют похода в бек.
 */
export const AsyncDefaultValues = memo<Props>(function AsyncDefaultValues({defaultValues}: Props): null {
  const searchParams = new URLSearchParams(useLocation().search)
  const {reset} = useFormContext()

  useTransition(
    async function toAsyncDefaultValues() {
      const from = searchParams.get('from') || undefined
      const to = searchParams.get('to') || undefined

      if (from) {
        return (
          Promise.resolve(defaultValues)
            .then(fetchInitialRoute(from, to))
            // обновлям стейт только если они не равны, так как в параметрах могут быть невалидные координаты
            .then(values => values !== defaultValues && reset(values))
        )
      }
    },
    {key: 'fetch/default-values'},
  )

  return null
})
